export default __webpack_public_path__ + "static/3-e94701ab59faffe36ae4bc45e836accd.jpg";